import {
	applySwitchIpv6AclFilter,
	focusSwitchIpv6Acl,
	openSwitchIpv6AclSection,
} from './adapter';
import {
	openSwitchIpv6AclCreateModal,
	openSwitchIpv6AclDeleteModal,
	openSwitchIpv6AclAddAceModal,
	openSwitchIpv6AclEditAceModal,
	openSwitchIpv6AclDeleteAceModal,
} from './modal';
import {resolveSwitchIpv6Acl} from './resolver';

/**
 * Switch IPv6 ACL.
 *
 * Same shape as the Switch MAC ACL: add an entry, or delete the ACL.
 *
 * Declares no fields: the agent finds one and opens the form rather than
 * filling it in.
 */
const switchIpv6AclPlugin = {
	id: 'switch_ipv6_acl',
	version: 1,
	commandVersion: 1,
	resource: 'switch_ipv6_acl',
	operations: ['options', 'list', 'edit', 'search', 'create', 'delete', 'add_ace', 'edit_ace', 'delete_ace'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.switch_ipv6_acls': openSwitchIpv6AclSection,
	},
	resolvers: {
		switch_ipv6_acl: resolveSwitchIpv6Acl,
	},
	filters: {
		switch_ipv6_acl: (command) =>
			applySwitchIpv6AclFilter(command.params?.query),
	},
	focusHandlers: {
		switch_ipv6_acl: (command) =>
			focusSwitchIpv6Acl(command.params?.entity_id),
	},
	modals: {
		'switch_ipv6_acl.create': openSwitchIpv6AclCreateModal,
		'switch_ipv6_acl.delete': openSwitchIpv6AclDeleteModal,
		'switch_ipv6_acl.add_ace': openSwitchIpv6AclAddAceModal,
		'switch_ipv6_acl.edit_ace': openSwitchIpv6AclEditAceModal,
		'switch_ipv6_acl.delete_ace': openSwitchIpv6AclDeleteAceModal,
	},
};

export default switchIpv6AclPlugin;
